import { useState } from 'react';
import PropTypes from 'prop-types';
import { Form } from '@ant-design/compatible';

import { AutoComplete, Modal, Row, notification, Input } from 'antd';
import Button from '@components/shared/V2Button';
import api from '@shared/api';
import routes from '@root/routes';
import { withTranslation } from 'react-i18next';
import { flow, isEmpty } from 'lodash/fp';
import { withRouter } from 'react-router-dom';
import { historyType } from '@propTypes/index';

const {
  api: {
    admin: { buildingSearch: buildingSearchQueryRoute, buildingLink: buildingLinkRoute },
  },
  admin: { building: buildingRoute },
} = routes;

function RawLinkBuildingModal({ visible, onCancel, t, propertyId, history }) {
  const [buildings, setBuildings] = useState([]);
  const [selectedBuildingId, setSelectedBuildingId] = useState();

  async function handleSearch(query = '') {
    if (query.length === 0) return;

    const res = await api.fetch(buildingSearchQueryRoute({ query }));
    const data = await res.json();

    setBuildings(data.buildings);
  }

  async function handleLink() {
    try {
      await api.post(buildingLinkRoute, { propertyId, buildingId: selectedBuildingId });
      history.push(buildingRoute(selectedBuildingId));
    } catch (e) {
      notification.error({ message: e.message });
    }
  }

  /* eslint-disable react/jsx-no-bind */
  return (
    <Modal
      visible={visible}
      onCancel={onCancel}
      title="Link to Existing Building"
      footer={
        <>
          <Button key="cancel" type="secondary" onClick={onCancel}>
            {t('common.cancelButton')}
          </Button>
          <Button key="link" onClick={handleLink} disabled={isEmpty(selectedBuildingId)}>
            {t('building.linkButton')}
          </Button>
        </>
      }
    >
      <Form layout="inline">
        <Row>
          <Form.Item label={t('building.searchLabel')}>
            <AutoComplete
              placeholder={t('building.searchPlaceholder')}
              style={{ width: 200 }}
              name="building-search"
              onSearch={handleSearch}
              autoFocus
              options={buildings.map(({ primaryName, id }) => ({
                value: id,
                label: primaryName,
              }))}
              onSelect={buildingId => setSelectedBuildingId(buildingId)}
            >
              <Input data-testid="building_search_input" name="building_search_input" />
            </AutoComplete>
          </Form.Item>
        </Row>
      </Form>
    </Modal>
  );
}
/* eslint-enable react/jsx-no-bind */

RawLinkBuildingModal.propTypes = {
  visible: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  propertyId: PropTypes.string.isRequired,
  history: historyType.isRequired,
};

RawLinkBuildingModal.defaultProps = {
  visible: false,
};

const EnhancedLinkBuildingModal = flow(withTranslation('admin'), withRouter)(RawLinkBuildingModal);
EnhancedLinkBuildingModal.displayName = 'LinkBuildingModal';

export { RawLinkBuildingModal };
export default EnhancedLinkBuildingModal;
